import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import assessIcon from 'assets/img/icons/assess.svg';

class ClientHeadMenu extends React.Component {
  render() {
    let { clientId } = this.props;
    return (
      <div className="page-dropdown">
        <Dropdown>
          <Dropdown.Toggle>
            <i className="fas fa-plus"></i>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Toggle>
              <i className="fas fa-times"></i>
            </Dropdown.Toggle>
            <div className="dropdown-content">
              <Dropdown.Item
                href={`/clients/${clientId}/notes/new`}
                className="btn btn-peach"
              >
                <i className="fas fa-clipboard"></i> Add Note
              </Dropdown.Item>
              <Dropdown.Item
                href={`/clients/${clientId}/goals/new`}
                className="btn btn-sandy"
              >
                <i className="fas fa-trophy"></i> Add Goal
              </Dropdown.Item>
              <Dropdown.Item
                href={`/clients/${clientId}/add-assessment`}
                className="btn btn-blue"
              >
                <img src={assessIcon} /> Add Assessment
              </Dropdown.Item>
              <Dropdown.Item
                href={`/clients/${clientId}/nutrition-assign`}
                className="btn btn-mint"
              >
                <i className="fas fa-carrot"></i> Assign Nutrition Plan
              </Dropdown.Item>
              <Dropdown.Item
                href={`/clients/${clientId}/workout-assign`}
                className="btn btn-purple"
              >
                <i className="fas fa-user-plus"></i> Assign Workouts
              </Dropdown.Item>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

export default ClientHeadMenu;
